module.exports = __webpack_public_path__ + "static/fonts/TerpelSans-Regular.a8aa874.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/TerpelSans/TerpelSans-Regular.woff2
// module id = r73l
// module chunks = 6